var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Tooltip',{staticClass:"beta-badge-wrap",attrs:{"text":_vm.$t('dash.beta.help'),"position":_vm.position}},[_c('span',{staticClass:"beta-badge"},[_vm._v(_vm._s(_vm.$t('dash.overview.beta')))])])}
var staticRenderFns = []

export { render, staticRenderFns }